import axios from 'axios';
import { Preferences } from '@capacitor/preferences';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const OAUTH_CALLBACK_URL = 'bloomingriceapp://oauth2/callback';
const CLIENT_ID = 'app-client';

export async function exchangeCodeForToken(code: string) {
  const { value: codeVerifier } = await Preferences.get({ key: 'code_verifier' });

  if (!codeVerifier) {
    throw new Error('Missing code_verifier');
  }

  const res = await axios.post(
    `${API_BASE_URL}/api/server/oauth2/token`,
    new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: CLIENT_ID,
      code,
      redirect_uri: OAUTH_CALLBACK_URL,
      code_verifier: codeVerifier,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );

  await Preferences.remove({ key: 'code_verifier' });

  return res.data;
}